import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { COLOR_PRIMARY } from "../../constants/color";
import { CheckboxIcon } from "./icons/CheckboxIcon";

type Props = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
};

export const TableCheckbox: React.FC<Props> = ({
  checked = false,
  onChange,
  disabled = false,
}) => {


  const handleClick = useCallback(() => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  }, [checked, onChange, disabled]);

  const fillColor = useMemo(() => {
    if (disabled) return "#e6e6e6";
    if (checked) return COLOR_PRIMARY;
    return "#E6E6E6";
  }, [disabled, checked]);

  return (
    <StyledCheckboxContainer
      $isChecked={checked}
      $disabled={disabled}
      onClick={handleClick}
    >
      <CheckboxIcon fillColor={fillColor} />
    </StyledCheckboxContainer>
  );
};

const StyledCheckboxContainer = styled.div<{
  $isChecked: boolean;
  $disabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  padding: 4px;
  border-radius: 4px;
`; 